import { MsalProvider } from "@azure/msal-react";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import App from "./App";
import { getMsalInstance, initAuth } from "./auth/bootstrapMsal";
import { store } from "./store";

async function start() {
  // 1. Load MSAL config from backend + initialize MSAL instance
  await initAuth();
  const msalInstance = getMsalInstance();

  // 2. Initialize MSAL (required before any API calls)
  await msalInstance.initialize();

  // 3. Handle redirect from login provider
  await msalInstance.handleRedirectPromise();

  // 4. Render App only AFTER MSAL is ready
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <Provider store={store}>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </Provider>
    </React.StrictMode>
  );
}

// Start the SPA bootstrap
start();
